import React from "react";
import "./Table.css";
import numeral from "numeral";

const Table = ({ countries }) => {
  return (
    <div className="h-96 overflow-y-scroll">
      <table className="table m-5 text-gray-500">
        <tbody>
          {countries.map(({ country, cases }) => (
            <tr
              className="flex justify-between odd:bg-slate-100"
              key={Math.random()}
            >
              <td className="p-2">{country}</td>
              <td className="p-2">
                <strong>{numeral(cases).format("0,0")}</strong>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
